import { memo, type FC } from 'react';

import { InfoTooltipIcon } from '../../../../Feedback/InfoTooltipIcon/index.tsx';
import { TableCardTitleWrapper } from './styled.ts';
import type { TableCardTitleProps } from './types.ts';

export const TableCardTitle: FC<TableCardTitleProps> = memo(function TableCardTitle({ className, tooltip, tooltipPosition, children }) {
  return (
    <TableCardTitleWrapper className={className}>
      <span>
        {children}
        {tooltip && <InfoTooltipIcon placement={tooltipPosition} tooltip={tooltip} size={24} />}
      </span>
    </TableCardTitleWrapper>
  );
});
